const state = {
    loading: true
}

const getters = {
    fetchLoading(state) {
        return state.loading;
    }
}

const actions = {
    setLoading(context, payload) {
        context.commit('SET_LOADING', payload);
    }
}

const mutations = {
    SET_LOADING(state, isLoading) {
        state.loading = isLoading;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}